import {Component, EventEmitter, Input, Output, SimpleChanges, ViewChild,} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Observable, Subject, takeUntil} from 'rxjs';
import {ColumnModel} from '../../../models/dx-data-table.model';
import {DlistDto} from '../../../models/ortak.dtos';
import {CtlRowEditSearchPopupService} from './ctl-row-edit-search-popup.service';
import {OrtakService} from '../../../services/ortak.service';
import {
  DxButtonModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonComponent,
  DxPopoverModule,
  DxPopupModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import {DkDxDataCtlTableComponent} from '../../components';
import {FilterDescriptor} from 'devextreme/data';
import {DataCoreService} from '../../../services/data-core.service';
import {ColumnEditCellTemplateData, FocusedCellChangingEvent} from 'devextreme/ui/data_grid';
import DataSource from 'devextreme/data/data_source';
import {UtilsService} from '../../../services/utils.service';

@Component({
  selector: 'dk-ctl-row-edit-search-popup',
  standalone: true,
  imports: [
    CommonModule,
    DxPopupModule,
    DkDxDataCtlTableComponent,
    DxButtonModule,
    DxPopoverModule,
    DxDateBoxModule,
    DxDropDownBoxModule,
    DxTextBoxModule
  ],
  templateUrl: './ctl-row-edit-search-popup.component.html',
  styleUrls: ['./ctl-row-edit-search-popup.component.scss'],
})
export class CtlRowEditSearchPopupComponent {
  @ViewChild('editTemplateDropDown', {static: false}) dropDown: DxDropDownButtonComponent;


  @ViewChild(DkDxDataCtlTableComponent, {static: false})
  grid!: DkDxDataCtlTableComponent;
  @Input() controlName: any;
  @Input() key: string;
  @Input() startsWithFilterColumn = '';
  @Input() startsWithFilterColumnValue: any;
  @Input() filterArr: FilterDescriptor | Array<FilterDescriptor>[] = [];
  @Input() cellValue: number | string;
  @Input() dataField: string;
  @Input() dropDownWidth: number;
  @Input() dropDownHeight: number;
  @Input() selectedValueDispName: string;
  @Input() cellInfo: ColumnEditCellTemplateData;

  @Output() public closePopUp: EventEmitter<any> = new EventEmitter();

  private destroy$ = new Subject<void>();
  public control!: any;
  public dataSource: DataSource;
  public selectedData: any = null;
  public columns: ColumnModel[];
  gridControlsList$: Observable<DlistDto>;

  public filterValue: any;

  gridCtlList: DlistDto;


  constructor(
    public service: CtlRowEditSearchPopupService,
    public ortakService: OrtakService,
    private dataCoreService: DataCoreService,
    private utilsService: UtilsService
  ) {
  }

  ngOnInit(): void {
    this.getControl();
    if (this.startsWithFilterColumnValue) {
      this.filterValue = [
        this.startsWithFilterColumn,
        'startswith',
        this.startsWithFilterColumnValue,
      ];
    }
  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cellValue'] && this.cellValue != null && this.control) {
      if(this.cellInfo.row.isEditing || this.cellInfo.row.isNewRow) {
        this.getDataWithKod(this.cellValue);
      }
    }
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

  }

  focusedCellChanging(event: FocusedCellChangingEvent) {

  }

  focusChanged(e: any, isDbClick: boolean) {
    this.startsWithFilterColumnValue = undefined;
    this.selectedData = e?.row ? e.row?.data : e?.data;
    if (isDbClick) {
      this.closePopUp.emit(this.selectedData);
      this.dropDown.instance.close();
    }
  }

  chooseBtnClick() {
    this.startsWithFilterColumnValue = undefined;
    this.closePopUp.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.startsWithFilterColumnValue = undefined;
    this.closePopUp.emit('close');
    this.dropDown.instance.close();
  }

  getControl() {
    this.ortakService
      .getControl(this.controlName)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
          this.control = data?.controlMetadata;
          this.gridCtlList = data?.controlMetadata?.dlistMetadata;
          this.columns = this.ortakService.setRecursiveFieldData([data?.controlMetadata?.dlistMetadata], false);

          this.dataSource = this.service.getData(
            this.control,
            this.filterArr,
            this.key
          );
        },
        (err) => {
          this.utilsService.showError('Kontrol bilgileri alınamadı!');
        });
  }

  getDataWithKod(kod: any) {
    if(kod === this.selectedData?.[this.key] ) return;
    this.service.getData(
      this.control,
      this.filterArr,
      this.key,
      kod).load().then((result: any) => {
      if (result?.length > 0) {
        // eşleşme varsa direk seç
        this.selectedData = result[0];
        this.closePopUp.emit(result[0]);
        if (this.selectedValueDispName) {
          this.utilsService.showInfo(result[0][this.selectedValueDispName] + ' seçildi.', 'Bilgi');
        }

      } else {
        if (!this.startsWithFilterColumn) {
          if (typeof kod === 'string') {
            this.filterValue = [this.key, 'startswith', kod]; // sayı için eşitlik kontrolü
          }
        }
        // eşleşme yoksa dropdown'u aç
        this.dropDown.instance.open()

      }
    })
  }


}
